import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "../../hooks/useTheme";
import { getImageUri } from "../../utils/functions/getImageUri";
import styles from "./ForceStoreSelector.module.scss";
import {
  selectStoreList,
  setForceStores,
} from "../../../store/slices/storeListSlice";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import { selectForceStores } from "../../../store/slices/storeListSlice";
import { selectExecutor } from "../../../store/slices/executorSlice";
import { globalSync } from "../../../hoc/useRootLayout";
import BottomModal from "../bottomModal/BottomModal";
import { clearCart } from "../../../store/slices/cartSlice";

export const ForceStoreSelector: React.FC = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const storeList = useSelector(selectStoreList);
  const currentCluster = useSelector(selectCurrentCluster);
  const forceStores = useSelector(selectForceStores);
  const executor = useSelector(selectExecutor);
   const isQsoil = currentCluster?.id === 7;

  const forceStoreEnabled = currentCluster?.forceStore ?? false;

  const getDisabledText = (clusterId: number) => {
    return clusterId === 6 ? "Скоро открытие" : "Временно не работает";
  };

  // Проверяем, доступна ли выбранная точка
  useEffect(() => {
    if (forceStores.length === 0) return;

    const selectedStore = storeList.find((s) => s.id === forceStores[0]);
    if (
      !selectedStore ||
      !selectedStore.isActive ||
      selectedStore.temporarilyDisabled
    ) {
      dispatch(setForceStores([]));
    }
  }, [forceStores, storeList, dispatch]);

  // Фильтруем: для менеджера — только его сторы
  const visibleStores = storeList.filter((store) => {
    if (!store.isActive) return false;

    if (executor?.stores && executor.stores.length > 0) {
      return executor.stores.some((s) => s.storeId === store.id);
    }

    return true;
  });

  const needSelection = forceStoreEnabled && forceStores.length === 0;

  const handleSelectStore = (storeId: number) => {
    dispatch(setForceStores([storeId]));
    dispatch(clearCart());
    if (globalSync.refreshCatalog) {
      globalSync.refreshCatalog();
    }
  };

  if (!needSelection) return null;

  if (visibleStores.length === 0) {
    return (
      <BottomModal isVisible={true} onClose={() => {}}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.title} style={{ color: theme.text }}>
              Нет доступных точек
            </h2>
          </div>
        </div>
      </BottomModal>
    );
  }

  return (
    <BottomModal isVisible={true} onClose={() => {}}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title} style={{ color: theme.text }}>
            {isQsoil ? 'Выберите склад отгрузки' :'Выберите филиал'}
          </h2>
        </div>

        <div className={styles.list}>
          {visibleStores.map((store) => {
            const isDisabled = store.temporarilyDisabled;
            return (
              <button
                key={store.id}
                className={`${styles.storeCard} ${isDisabled ? styles.disabled : ""}`}
                style={{
                  backgroundColor: theme.card,
                  borderColor: theme.border,
                }}
                onClick={() => !isDisabled && handleSelectStore(store.id)}
                disabled={isDisabled}
              >
                {store.files?.[0] && (
                  <img
                    className={styles.image}
                    src={`${getImageUri()}${store.files[0]}`}
                    alt={store.name}
                  />
                )}
                <div className={styles.content}>
                  <div
                    className={styles.storeName}
                    style={{ color: theme.text }}
                  >
                    {store.name}
                  </div>
                  <div
                    className={styles.storeAddress}
                    style={{ color: theme.textSecondary }}
                  >
                    {store.address?.value ||
                      store.description ||
                      "Адрес не указан"}
                  </div>
                  {isDisabled && (
                    <div
                      className={styles.disabledBadge}
                      style={{ color: theme.primary }}
                    >
                      {getDisabledText(currentCluster?.id ?? 0)}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </BottomModal>
  );
};
